import axios from "axios";
import { EVENT_SERVER_URL } from "../config/config";

class EventApiService {
  constructor() {
    this.client = axios.create({
      baseURL: EVENT_SERVER_URL + "/events/v1",
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.client.interceptors.response.use(
      (response) => response.data,
      (error) => {
        console.error("API Error:", error);
        if (error.response) {
          return Promise.reject({
            message: error.response.data?.message || "Server error",
            status: error.response.status,
            data: error.response.data,
          });
        } else if (error.request) {
          return Promise.reject({
            message: "Network error - unable to connect to server",
            status: 0,
          });
        } else {
          return Promise.reject({
            message: error.message || "Unknown error occurred",
            status: -1,
          });
        }
      }
    );
  }

  async getEventConfig(eventSlug) {
    try {
      const response = await this.client.get(`/${eventSlug}/config`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async calculatePricing(eventSlug, pricingData) {
    try {
      const response = await this.client.post(
        `/${eventSlug}/calculate-pricing`,
        pricingData
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async submitForm(eventSlug, formData) {
    try {
      const response = await this.client.post(`/${eventSlug}/form`, formData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async createPaymentIntent(eventSlug, paymentData) {
    try {
      const response = await this.client.post(
        `/${eventSlug}/payment-intent`,
        paymentData
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async verifyPayment(eventSlug, paymentDetails) {
    try {
      const response = await this.client.post(
        `/${eventSlug}/verify-payment`,
        paymentDetails
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getCustomerDetails(eventSlug, customerId, orderId) {
    try {
      const response = await this.client.get(
        `/${eventSlug}/customer/verify?customer_id=${customerId}&order_id=${orderId}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async addAttendees(eventSlug, attendeeData) {
    try {
      const response = await this.client.post(
        `/${eventSlug}/attendees`,
        attendeeData
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export const eventApiService = new EventApiService();
export default eventApiService;
